import FullContentContainer from '@map/components/layout/FullContentContainer';
import { makeStyles } from '@map/theme';
import { ComponentProps } from 'react';

const useStyles = makeStyles(() => ({
  root: {
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
}));

const LoadingDialog: FC<ComponentProps<typeof FullContentContainer>> = (props) => {
  const { classes, cx } = useStyles();
  return (
    <FullContentContainer {...props} className={cx(classes.root, props.className)}>
      <div className="sk-spinner inverse">
        <b />
        <b />
        <b />
      </div>
    </FullContentContainer>
  );
};

export default LoadingDialog;
